module.exports = __webpack_public_path__ + "img/action-report-active.7e255fef.svg";